import { useState } from 'react'
import { useAdminRoles } from '../../../features/admin/use-admin-roles'
import { useAdminUsers, useAssignUserRole } from '../../../features/admin/use-admin-users'
import { AdminPage, adminError, td } from './admin-bits'
import { Inline, input, th } from './controls'
import { Note, Section, serif } from './ui'

export function LedgerAdminUsers() {
  const users = useAdminUsers()
  const roles = useAdminRoles()
  const assign = useAssignUserRole()
  const [target, setTarget] = useState<string | null>(null)
  const list = users.data ?? []
  const roleOpts = roles.data ?? []
  return (
    <AdminPage
      title="Users"
      standfirst="Everyone in the organization, and the role each one holds."
      loading={users.isLoading}
      error={!!users.error}
    >
      <Section title={`${list.length} ${list.length === 1 ? 'member' : 'members'}`}>
        {assign.error ? <Inline tone="bad">{adminError(assign.error)}</Inline> : null}
        {list.length === 0 ? (
          <Note>No users in this organization.</Note>
        ) : (
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className={th}>Name</th>
                <th className={th}>Email</th>
                <th className={th}>Role</th>
              </tr>
            </thead>
            <tbody>
              {list.map((u) => (
                <tr key={u.id}>
                  <td className={`${td} text-[16px] font-semibold`} style={serif}>
                    {u.name}
                  </td>
                  <td className={`${td} text-[var(--color-muted)]`}>{u.email}</td>
                  <td className={td}>
                    <select
                      aria-label={`Role for ${u.name}`}
                      className={`${input} max-w-[220px]`}
                      value={u.role}
                      disabled={assign.isPending && target === u.id}
                      onChange={(e) => {
                        setTarget(u.id)
                        assign.mutate({ userId: u.id, role: e.target.value })
                      }}
                    >
                      {roleOpts.some((r) => r.id === u.role) ? null : <option value={u.role}>{u.role}</option>}
                      {roleOpts.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.name}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Section>
    </AdminPage>
  )
}
